<div class="onboarding-container">
    <div class="onboarding-card">
        <!-- Logo Section -->
        <div class="logo-section">
            <div class="logo-icon">
                <img src="/assets/img/logo-no-bg.png" alt="" />
            </div>
        </div>

        <!-- Content Section -->
        <div class="content-section">
            <h1 class="welcome-title">
                {{ getCurrentStep().title }}
            </h1>

            <div class="description">
                <p *ngFor="let paragraph of getCurrentStep().description">
                    {{ paragraph }}
                </p>
            </div>
        </div>

        <!-- Navigation Section -->
        <div class="navigation-section">
            <button
                type="button"
                class="nav-btn prev-btn"
                [class.disabled]="currentStep === 0"
                (click)="onPrevious()"
                [disabled]="currentStep === 0"
            >
                <svg
                    width="34"
                    height="34"
                    viewBox="0 0 34 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M13.6862 8.72308L5.40894 17.0004L13.6862 25.2776"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M28.5907 17.0004H5.64075"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </button>

            <div class="progress-dots">
                <span
                    class="dot"
                    *ngFor="let step of getSteps(); let i = index"
                    [class.active]="i === currentStep"
                ></span>
            </div>

            <button
                type="button"
                class="nav-btn next-btn"
                [class.with-text]="currentStep === totalSteps - 1"
                (click)="onNext()"
            >
                <span class="btn-text" *ngIf="currentStep === totalSteps - 1"
                    >Get Started</span
                >
                <svg
                    width="34"
                    height="34"
                    viewBox="0 0 34 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M20.3138 8.72308L28.5911 17.0004L20.3138 25.2776"
                        stroke="black"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M5.40925 17.0004H28.3593"
                        stroke="black"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </button>
        </div>
    </div>
</div>
